import { addToast } from '@heroui/react';

const DEFAULT_TOAST_TIMEOUT = 5000;

interface ToastProps {
  title?: string;
  description?: string;
  timeout?: number;
}

export const successToast = (toastProps: ToastProps) => {
  addToast({
    title: toastProps.title,
    description: toastProps.description,
    color: 'success',
    timeout: toastProps.timeout ?? DEFAULT_TOAST_TIMEOUT
  });
};

export const errorToast = (toastProps: ToastProps) => {
  addToast({
    title: toastProps.title,
    description: toastProps.description,
    color: 'danger',
    timeout: toastProps.timeout ?? DEFAULT_TOAST_TIMEOUT
  });
};

export const infoToast = (toastProps: ToastProps) => {
  addToast({
    title: toastProps.title,
    description: toastProps.description,
    color: 'default',
    timeout: toastProps.timeout ?? DEFAULT_TOAST_TIMEOUT
  });
};
